import React, { useState } from 'react'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import { InfoContainer3, InfoWrapper, TextImageSection, TextBlock, ImageBlock, Tile, TilesContainer } from '../components/InfoSection/InfoElements'

const Consult = () => {
    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }

  return (
    <>
    <Navbar toggle={toggle} />
    <Sidebar isOpen={isOpen} toggle={toggle} />
    <InfoContainer3 lightBg='true'>
                <InfoWrapper>
                  <div>
                    <TextImageSection>
                      <TextBlock>
                        <h2>Konsultacje projektowe</h2>
                        <p>
Prowadzę indywidualne konsultacje dotyczące osobistych ceremonii, zarówno tych
tworzonych dla bliskich, jak i planowanych z wyprzedzeniem – np. w ramach własnej woli lub
testamentu. Wspieram w projektowaniu rytuałów, które są prawdziwym wyrazem uczuć,
wartości i historii życia.                        </p>
                        <p>
Podczas takiego spotkania możesz:</p>
<p>– zaplanować przebieg ceremonii pożegnania bliskiej osoby lub własnego pogrzebu,</p>
<p>– stworzyć wieczór wspomnień, krąg pożegnań lub rytuał pamięci,</p>
<p>– włączyć do uroczystości symboliczne elementy, które odzwierciedlają ducha osoby, której
dotyczy ceremonia,</p>
<p>– otrzymać narzędzia i wskazówki, które pomogą Ci zrealizować wizję w zgodzie z Twoimi
wartościami i potrzebami.</p>
<p>Takie konsultacje są szczególnie pomocne dla osób, które:</p>
<p>– chcą samodzielnie poprowadzić ceremonię,</p>
<p>– współpracują z duchownym lub mistrzem ceremonii, ale pragną, by pojawił się w niej
osobisty, symboliczny akcent,</p>
<p>– planują swój własny pogrzeb za życia, np. w sytuacji choroby terminalnej lub z potrzeby
uporządkowania spraw i pozostawienia po sobie świadomego śladu.</p>
<p>Podczas spotkania dzielę się swoim profesjonalnym doświadczeniem i wiedzą, pomagając
ułożyć scenariusz dnia, dobrać odpowiednie słowa, muzykę i rytuały. Wspólnie tworzymy
przestrzeń, która będzie prawdziwa – nieformalna, a jednocześnie głęboko znacząca.</p>
<p>Zazwyczaj konsultacja trwa około 1,5–2 godziny (czasem dłużej, jeśli wymaga tego proces).</p>
<p>Koszt spotkania wynosi 300–400 zł, w zależności od długości i zakresu pracy.</p>
<p>Każda z takich rozmów jest wyjątkowa – tak jak historie, które za nimi stoją.</p>
<p>To przestrzeń spotkania sensu, pamięci i miłości – zaprojektowana tak, by stała się mostem
między tym, co było, a tym, co pozostaje w nas żywe.   </p>                     
                      </TextBlock>
                      {/* <ImageBlock>
                        <img src={img5} alt="Atenida" />
                      </ImageBlock> */}
                    </TextImageSection>
                  </div>
                </InfoWrapper>
    </InfoContainer3>
    <Footer />
    </>
  )
}

export default Consult